import "../../styles/store.css";
import store from "../../data/store";
import storeImage from "../../assets/images/store-image.jpg";

import { Link as RouterLink } from "react-router-dom";


export default function Store() {
    return (
        <div className="store">
            <header className="store__header">
                <div className="store__header-container">
                    <div className="store__header-start">
                        <img
                            src={storeImage}
                            alt="store-image"
                            className="store__image"
                        />
                    </div>
                    <div className="store__header-end">
                        <h1> al saleh templates store</h1>
                        <h3>owned by : Abdalla Saleh</h3>
                        <h4>Phone : +20-01111705681</h4>
                    </div>
                </div>
            </header>
            <section className="store__content">
                <div className="store__content-container">
                    <div className="store__content-title">
                        <h2>Latest Products</h2>
                    </div>
                    <div className="grid-container grid-container--columns">
                        {store.map((item) => (
                            <RouterLink key={item.id} to={item.link} target="_blank" className="store-card">
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="store-card__image"
                                />
                                <div className="store-card__body">
                                    <h3>{item.title}</h3>
                                    <p>
                                        {item.description}
                                    </p>
                                    <b>
                                        {item.price}
                                    </b>
                                </div>
                            </RouterLink>
                        ))}
                    </div>
                </div>
            </section>
            <footer className="store__footer">
                <span>
                    &copy; All rights reserved for Abdalla Saleh
                </span>
            </footer>
        </div>
    )
}